import { useQuery } from '@tanstack/react-query'
import min from 'lodash-es/min'
import omit from 'lodash-es/omit'
import values from 'lodash-es/values'

import api from '@api/location'

const baseKey = 'addressValidation'

type InputAddress = {
  addressLines: string[]
  city: string
  zip?: string
  zipCode?: string
  countryCode: string
  provinceCode?: string
}

type Response = {
  primaryLine: string
  secondaryLine: string
  urbanization: string
  city: string
  provinceCode?: string
  zipCode: string
  countryCode: string
  addressType: 'COMMERCIAL' | 'RESIDENTIAL' | 'UNKNOWN'
  deliverability: 'DELIVERABLE' | 'DELIVERABLE_MISSING_INFO' | 'UNDELIVERABLE'
  lat: string | null
  long: string | null
}

const useAddressValidation = (payload: InputAddress) => {
  const [primaryLine = '', secondaryLine = ''] = payload.addressLines || []

  const apiPayload = {
    primaryLine,
    secondaryLine,
    zipCode: payload.zip || payload.zipCode,
    countryCode: payload.countryCode,
    provinceCode: payload.provinceCode,
    city: payload.city,
  }

  const enabled = !!min(values(omit(apiPayload, ['secondaryLine'])))

  return useQuery({
    queryKey: [baseKey, apiPayload],
    queryFn: () => api.validateAddress(apiPayload),
    enabled,
  })
}

export { useAddressValidation }
export type { Response as AddressValidationResponse }
